var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntegrationsMenuItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 2.75H10.25V6.00287H9.75002V3.25H1.25V17.1638H16.8965L15.7323 15.9996C15.6346 15.9019 15.6346 15.7437 15.7323 15.646C15.8299 15.5484 15.9882 15.5484 16.0858 15.646L17.6768 17.237C17.7744 17.3346 17.7744 17.4929 17.6768 17.5906L16.0858 19.1816C15.9882 19.2792 15.8299 19.2792 15.7323 19.1816C15.6346 19.0839 15.6346 18.9256 15.7323 18.828L16.8965 17.6638H0.75V2.75Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.25 25.25H12.75V21.9971H13.25V24.75H21.75V10.8362L6.10352 10.8362L7.26773 12.0004C7.36536 12.0981 7.36536 12.2563 7.26773 12.354C7.1701 12.4516 7.01181 12.4516 6.91418 12.354L5.32319 10.763C5.22556 10.6654 5.22556 10.5071 5.32319 10.4094L6.91418 8.81844C7.01181 8.72081 7.1701 8.72081 7.26773 8.81844C7.36536 8.91607 7.36536 9.07436 7.26773 9.17199L6.10352 10.3362L22.25 10.3362L22.25 25.25Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationsMenuItem);
export default __webpack_public_path__ + "static/media/integrations-menu-item.8569d224.svg";
export { ForwardRef as ReactComponent };